import { MultiSelect } from "@carbon/react";
import { ControllerRenderProps, UseFormReturn, useWatch } from "react-hook-form";

import { useT } from "src/internationalization";
import { useConfList } from "src/providers/ConfListsProvider";

import { RuleFormData } from "./useRuleDefinition";

export type ConfListMultiPickerFormFieldProps = {
  index: number;
  id: string;
  disabled: boolean;
  onLoad?: () => void;
  onError?: () => void;
  method: UseFormReturn<RuleFormData, undefined, RuleFormData>;
  field: ControllerRenderProps<RuleFormData, `criteria.${number}.value`>;
};

export function ConfListMultiPickerFormField({
  index,
  disabled,
  id,
  method,
  field,
}: ConfListMultiPickerFormFieldProps) {
  const { control } = method;
  const confListCode =
    useWatch({ control, name: "criteria" })[index].property?.confListCode || null;

  const t = useT();

  const confList = useConfList(confListCode ?? "");

  const currentValues = field.value ? field.value.split(",") : [];
  const selectedItems = confList?.elements?.filter((el) => currentValues.includes(el.code)) ?? [];

  return (
    <MultiSelect
      id={`value-${id}`}
      titleText={t("page.rules.modal.create.form.filters.value.label")}
      label={
        selectedItems.length > 0
          ? selectedItems.map((item) => item.name).join(", ")
          : t("page.rules.modal.create.form.filters.value.placeholder")
      }
      items={confList?.elements?.filter((el) => !el.disabled) ?? []}
      itemToString={(item) => item?.name || ""}
      selectedItems={selectedItems}
      onChange={({ selectedItems }) => {
        const codes = (selectedItems ?? []).map((item) => item.code).join(",");
        field.onChange(codes);
      }}
      disabled={disabled}
    />
  );
}
